module.exports = __webpack_public_path__ + "ba22bd706c0e50c64b724c07825356df.png";